import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import ROUTES from '../../nav/Routes';
import axios from 'axios';

const CareerDetail = () => {
    let { id } = useParams();
    const [CareerObject, setCareerObject] = useState({});

    useEffect(() => {
        axios.get(
            // `http://localhost:8080/mann/careerDetail.php?id=${id}`
            `https://manncarriers.com/server/careerDetail.php?id=${id}`

        ).then((response) => {
            console.log(response.data.data);
            setCareerObject(response.data.data);
        });
    }, [id]);

    return (
        <div>
            <h2>Career Application Detail</h2>
            <div>
                <dl className="dl-horizontal">
                    <div className="AdminAlign">
                        <dt>First Name</dt>
                        <dd><p>{CareerObject.firstname}</p></dd>
                    </div>
                    <div className="AdminAlign">
                        <dt>Middle Name</dt>
                        <dd><p>{CareerObject.middlename}</p></dd>
                    </div>
                    <div className="AdminAlign">
                        <dt>Last Name</dt>
                        <dd><p>{CareerObject.lastname}</p></dd>
                    </div>
                    <div className="AdminAlign">
                        <dt>Date of Birth</dt>
                        <dd><p>{CareerObject.dbo}</p></dd>
                    </div>
                    <div className="AdminAlign">
                        <dt>Experience</dt>
                        <dd><p>{CareerObject.experience}</p></dd>
                    </div>
                    <div className="AdminAlign">
                        <dt>Application Type</dt>
                        <dd><p>{CareerObject.applicationtype}</p></dd>
                    </div>
                    <div className="AdminAlign">
                        <dt>SSN No</dt>
                        <dd><p>{CareerObject.ssnno}</p></dd>
                    </div>
                    <div className="AdminAlign">
                        <dt>Address</dt>
                        <dd><p>{CareerObject.address}</p></dd>
                    </div>
                    <div className="AdminAlign">
                        <dt>Phone</dt>
                        <dd><p>{CareerObject.phone}</p></dd>
                    </div>
                    <div className="AdminAlign">
                        <dt>Email</dt>
                        <dd><p>{CareerObject.email}</p></dd>
                    </div>
                    <div className="AdminAlign">
                        <dt>Postal Code</dt>
                        <dd><p>{CareerObject.postalcode}</p></dd>
                    </div>
                    <div className="AdminAlign">
                        <dt>Date</dt>
                        <dd><p>{CareerObject.datetime}</p></dd>
                    </div>
                </dl>
                <Link to={ROUTES.CareerApplicationList.name}>Go Back</Link>
            </div>
        </div>
    );
};

export default CareerDetail;
